import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

export default function LegalBanner() {
  const [visible, setVisible] = useState(false)
  const [mounted, setMounted] = useState(true)

  useEffect(() => {
    const dismissed = localStorage.getItem('cram:legalBannerDismissed')
    if (!dismissed) {
      // show the banner
      // small delay to allow page paint before animating in
      requestAnimationFrame(() => setVisible(true))
    } else {
      // don't render at all if previously dismissed
      setMounted(false)
    }
  }, [])

  function handleDismiss() {
    // start the slide-down animation
    setVisible(false)
    try {
      localStorage.setItem('cram:legalBannerDismissed', '1')
    } catch (e) {
      // ignore localStorage failures
    }
    // remove from DOM after transition (duration-500 -> wait slightly longer)
    window.setTimeout(() => setMounted(false), 520)
  }

  function dismissAndNavigate() {
    // persist dismissal and animate out; allow Link navigation to proceed
    try {
      localStorage.setItem('cram:legalBannerDismissed', '1')
    } catch (e) {
      // ignore
    }
    setVisible(false)
    window.setTimeout(() => setMounted(false), 520)
  }

  if (!mounted) return null

  return (
    <div className="fixed left-0 right-0 bottom-0 z-50 pointer-events-none px-4 sm:px-6">
      <div
        role="region"
        aria-label="Legal notification"
        className={`mx-auto max-w-4xl w-full pointer-events-auto transform transition-all duration-500 ease-in-out ${
          visible ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'
        }`}
        style={{ willChange: 'transform, opacity' }}
      >
        <div className="backdrop-blur-md bg-white/80 dark:bg-slate-900/70 shadow-lg rounded-xl px-4 py-2 sm:py-3 sm:px-5 flex items-center gap-4">
          <p className="text-sm text-slate-700 dark:text-slate-200 leading-5">
            Welcome to CRAM Finance! We encourage you to review our{' '}
            <Link to="/terms" onClick={dismissAndNavigate} className="underline decoration-sky-500 hover:decoration-sky-600">
              Terms of Use
            </Link>
            ,{' '}
            <Link to="/privacy" onClick={dismissAndNavigate} className="underline decoration-sky-500 hover:decoration-sky-600">
              Privacy Policy
            </Link>
            , and{' '}
            <Link to="/disclosure" onClick={dismissAndNavigate} className="underline decoration-sky-500 hover:decoration-sky-600">
              Affiliate Disclosure
            </Link>{' '}
            before exploring our student resources.
          </p>

          <div className="ml-auto flex-shrink-0">
            <button
              onClick={handleDismiss}
              className="ml-2 inline-flex items-center rounded-md bg-transparent px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-100 dark:text-slate-200 dark:hover:bg-slate-800 transition-colors"
              aria-label="Dismiss legal banner"
            >
              No thanks
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
